import React from 'react';
import { RiPhoneLine } from 'react-icons/ri';
import { useCall } from '../context/CallContext';

const styles = `
  @keyframes icmPulseRing {
    0% { transform: scale(1); opacity: 1; }
    100% { transform: scale(1.8); opacity: 0; }
  }
  @keyframes icmFadeIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }
  @keyframes icmGlow {
    0%, 100% { box-shadow: 0 0 20px #00ff0060; }
    50% { box-shadow: 0 0 40px #00ff00a0; }
  }
`;

export default function IncomingCallModal() {
  const { incomingCall, acceptCall, declineCall } = useCall();

  if (!incomingCall) return null;

  const callerDisplay = incomingCall.from
    ? incomingCall.from.slice(0, 8) + '...' + incomingCall.from.slice(-6)
    : 'Unknown';

  return (
    <>
      <style>{styles}</style>
      <div style={{
        position: 'fixed', inset: 0, zIndex: 99998,
        background: 'linear-gradient(135deg, #050010 0%, #0d001f 60%, #020008 100%)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Orbitron, sans-serif',
        animation: 'icmFadeIn 0.25s ease-out',
      }}>
        {/* Background grid */}
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none',
          backgroundImage: 'linear-gradient(rgba(0,255,0,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(0,255,0,0.03) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }} />

        {/* Avatar with pulsing green ring */}
        <div style={{ position: 'relative', marginBottom: '32px' }}>
          <div style={{
            position: 'absolute', inset: '-24px',
            borderRadius: '50%', border: '2px solid #00ff00',
            animation: 'icmPulseRing 1.4s ease-out infinite',
          }} />
          <div style={{
            position: 'absolute', inset: '-24px',
            borderRadius: '50%', border: '2px solid #00ff00',
            animation: 'icmPulseRing 1.4s ease-out 0.7s infinite',
          }} />
          <div style={{
            width: '96px', height: '96px', borderRadius: '50%',
            background: 'linear-gradient(135deg, #001a00, #003300)',
            border: '3px solid #00ff00',
            animation: 'icmGlow 2s ease-in-out infinite',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            position: 'relative', zIndex: 1,
          }}>
            <RiPhoneLine size={40} style={{ color: '#00ff00', textShadow: '0 0 12px #00ff00' }} />
          </div>
        </div>

        {/* Label */}
        <div style={{ fontSize: '11px', color: '#00ff00', letterSpacing: '4px', marginBottom: '12px', opacity: 0.9 }}>
          INCOMING ENCRYPTED CALL
        </div>

        {/* Caller */}
        <div style={{ fontSize: '15px', color: '#00ffff', textShadow: '0 0 10px #00ffff', marginBottom: '6px', letterSpacing: '1px' }}>
          {callerDisplay}
        </div>

        {/* Encryption badge */}
        <div style={{
          fontSize: '9px', color: '#00ff00', opacity: 0.7, letterSpacing: '2px',
          marginBottom: '48px',
          background: 'rgba(0,255,0,0.07)', border: '1px solid rgba(0,255,0,0.2)',
          borderRadius: '20px', padding: '4px 12px',
        }}>
          E2E · DTLS-SRTP · P2P
        </div>

        {/* Accept / Decline buttons */}
        <div style={{ display: 'flex', gap: '48px', alignItems: 'center' }}>
          {/* Decline */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
            <button
              onClick={declineCall}
              style={{
                width: '68px', height: '68px', borderRadius: '50%',
                background: 'linear-gradient(135deg, #cc0000, #ff2222)',
                border: '3px solid #ff4444',
                color: '#ffffff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', transition: 'all 0.2s ease',
                boxShadow: '0 0 25px rgba(255,0,0,0.5)',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
            >
              <RiPhoneLine size={28} style={{ transform: 'rotate(135deg)' }} />
            </button>
            <span style={{ fontSize: '10px', color: '#ff4444', letterSpacing: '1px' }}>DECLINE</span>
          </div>

          {/* Accept */}
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
            <button
              onClick={acceptCall}
              style={{
                width: '68px', height: '68px', borderRadius: '50%',
                background: 'linear-gradient(135deg, #006600, #00aa00)',
                border: '3px solid #00ff00',
                color: '#ffffff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', transition: 'all 0.2s ease',
                boxShadow: '0 0 25px rgba(0,255,0,0.5)',
                animation: 'icmGlow 1.5s ease-in-out infinite',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
            >
              <RiPhoneLine size={28} />
            </button>
            <span style={{ fontSize: '10px', color: '#00ff00', letterSpacing: '1px' }}>ACCEPT</span>
          </div>
        </div>
      </div>
    </>
  );
}
